<template>
  <div>
    <v-card color="grey lighten-5" flat>
      <v-form>
        <v-layout flex wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{baslik}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn v-if="this.$route.query.islem == 'yeni'" @click="ekle()" class="white--text" flat ><span
                  class="hidden-sm-and-down">Kaydet</span>
                <v-icon right dark >add_box</v-icon>
              </v-btn>
              <v-btn v-if="this.$route.query.islem == 'guncelle'" @click="guncelle()" class="white--text" flat><span
                  class="hidden-sm-and-down">Güncelle </span>
                <v-icon right dark>system_update_alt</v-icon>
              </v-btn>
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <a target="_self" v-bind:href="'#/musteri/index/'">
                    <v-list-tile>
                      <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          <v-tabs style="width:100%; height:100%;" dark="" v-model="active" color="blue darken-3" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0' >
              Genel
            </v-tab>
            <v-tab-item :id="'0'"  style="width:100%; height:500px;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-form ref="formmusteri" v-model="valid" lazy-validation>
                          <v-layout justify-space-between column>
                            <v-layout flex wrap>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="Müşteri Kod" v-model="Musteri.MusteriKod">
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="Grup" v-model="Musteri.Grup"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="Cari Kod" v-model="Musteri.CariKod"></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout flex wrap>
                              <v-flex xs12 sm4 md12>
                                <v-text-field hide-details="" label="Müşteri Adı" :rules="[v => !!v || 'Zorunlu alan']"
                                  v-model="Musteri.Ad">
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md12>
                                <v-text-field hide-details="" label="Acenta Adı" :rules="[v => !!v || 'Zorunlu Alan']"
                                  v-model="Musteri.AcenteAdi">
                                </v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-layout flex wrap>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="Ülke" v-model="Musteri.Ulke"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="Şehir" v-model="Musteri.Sehir"></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field hide-details="" label="İlçe" v-model="Musteri.Ilce"></v-text-field>
                              </v-flex>
                              <v-text-field hide-details="" label="Web" v-model="Musteri.Web"></v-text-field>
                            </v-layout>
                            <v-layout flex wrap>
                              <v-flex xs12 sm4 md2>
                                <v-checkbox label="Firma Kapandı" v-model="Musteri.Kapandi" hide-details>
                                </v-checkbox>
                                 </v-flex>
                                <v-flex xs12 sm4 md2>
                          <v-checkbox label="Web'de Gizli" v-model="Musteri.WebGizle" hide-details>
                          </v-checkbox>
                        </v-flex>
                             
                            </v-layout>
                          </v-layout>
                        </v-form>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-textarea v-model="Musteri.Adres" label="Adres"></v-textarea>
                          <v-textarea v-model="Musteri.Notlar" label="Notlar"></v-textarea>
                          <v-textarea v-model="Musteri.OnemliNot" label="Önemli Notlar"></v-textarea>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab href='#1' ripple>
              Database Bİlgİlerİ
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md4>
                  <v-card class="white--text">
                    <v-card color="grey lighten-4" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-text-field hide-details="" label="Müşteri Ip" v-model="Musteri.MusteriIp">
                          </v-text-field>
                          <v-text-field hide-details="" label="Database Şifre" v-model="Musteri.DBPassword">
                          </v-text-field>
                          <v-text-field hide-details="" label="Cari Database Adı" v-model="Musteri.DBCariName">
                          </v-text-field>
                          <v-text-field hide-details="" label="Bilet Database Adı" v-model="Musteri.DBBiletName">
                          </v-text-field>
                          <v-text-field hide-details="" label="Coper Database Adı" v-model="Musteri.DBCoperName">
                          </v-text-field>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab href='#2' v-if="this.$route.query.islem == 'guncelle'" >
              Yetkili Bİlgİlerİ
            </v-tab>
            <v-tab-item :id="'2'" style="width:100%; height:100%;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text"  flat>
                    <v-form ref="formyetkili"  lazy-validation>
                    <v-layout flex wrap>
                      <v-text-field v-model="yetkiliKayit.Unvan" label="Ünvan " :rules="[v => !!v || 'Zorunlu alan']"></v-text-field>
                      <v-text-field hide-details="" v-model="yetkiliKayit.Yetkili" label="Yetkili" :rules="[v => !!v || 'Zorunlu alan']"></v-text-field>
                      <v-btn @click="yetkiKayit" icon>
                        <v-icon color="primary"> add_box</v-icon>
                      </v-btn>
                    </v-layout>
                    </v-form>
                  </v-card>
                </v-flex>
              </v-layout>

              <v-layout flex="" wrap="" >
                 <v-flex  pa-1 xs12 sm6 md6>
                   <v-form ref="formyetkiliguncel"  lazy-validation>
                      <v-card  flat>
                    <template v-for="(item,index) in authorizedArray">
                      <v-layout flex wrap v-bind:key="item.MusteriKod">
                        <v-flex xs3 sm3 md6>
                          <v-layout flex wrap align-start justify-start="">
                            <v-card  flat>
                              <v-flex>
                                 <v-list-tile >
                                    <div class="font-weight-bold body-1">
                                    {{item.Unvan}}
                                    </div>
                                    </v-list-tile>
                              </v-flex>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md4>
                          <v-layout column="" align-start>
                            <v-card  flat> 
                                  <v-layout align-center>
                                    <v-flex>
                                        <v-list-tile>
                                    <div class="font-weight-bold body-1">
                                          {{item.Yetkili}}
                                         </div>
                                    </v-list-tile>
                                    </v-flex>
                                  </v-layout>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md2>
                          <v-layout column="" align-start>
                            <v-card class="white--text"  flat>
                              <v-list-tile >
                                <v-list-tile-content >
                                  <v-layout align-center>
                                    <v-flex >
                                      <v-layout class="white--text"  flat>
                                        <v-card class="white--text"  flat>
                                          <v-dialog v-model="yetkiliDuzenle" persistent max-width="400px">
                                            <v-flex xs12 sm12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Güncelle</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template  v-slot:activator="{ on }">
                                              <v-btn   v-on="on" icon>
                                                <v-icon color="green" @click="yetkiCek(item,index)">edit</v-icon>
                                              </v-btn>
                                            </template>
                                            <v-flex>
                                              <v-layout wrap>
                                                <v-card class="white--text">
                                                  <v-card  flat="">
                                                    <v-card-actions>
                                                      <v-layout row wrap>
                                                        <v-flex pa-1 xs12 sm12 md12>
                                                          <v-layout>
                                                            <v-text-field label="Ünvan" v-model="yetkiliVeri.Unvan" :rules="[v => !!v || 'Zorunlu alan']">
                                                            </v-text-field>
                                                          </v-layout>
                                                        </v-flex>
                                                        <v-flex pa-1 xs12 sm12 md12>
                                                          <v-layout>
                                                            <v-text-field label="Yetkili Adı" v-model="yetkiliVeri.Yetkili" :rules="[v => !!v || 'Zorunlu alan']">
                                                            </v-text-field>
                                                          </v-layout>
                                                        </v-flex>
                                                      </v-layout>
                                                    </v-card-actions>
                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="info" flat @click.native="yetkiliDuzenle = false" >Vazgeç</v-btn>
                                                      <v-btn color="info" flat @click="yetkiGuncelle()">Güncelle
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                                </v-card>
                                              </v-layout>
                                            </v-flex>
                                          </v-dialog>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                        <v-card class="white--text"  flat>
                                          <v-dialog v-model="yetkiliSilKontrol" persistent max-width="400px">
                                        <v-flex xs12 sm12 md12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Uyarı!</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template  v-slot:activator="{ on }">
                                              <v-btn @click="yetkiSilDialog(item.Ref)" @click.native="yetkiliSilKontrol = true" v-on="on" icon>
                                            <v-icon color="red">delete</v-icon>
                                              </v-btn>
                                            </template>
                                                  <v-card color="grey lighten-5">
                                                      <v-card-text>
                                                    Silmek istediğinize emin misiniz?
                                                  </v-card-text>
                                                      <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="primary" flat @click.native="yetkiliSilKontrol = false">Vazgeç</v-btn>
                                                      <v-btn color="primary" flat @click="yetkiliSil(item)"  @click.native="yetkiliSilKontrol = false">Tamam
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                
                                          </v-dialog>
                                        </v-card>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider :key="item.id"></v-divider>
                    </template>
                      </v-card>
                     </v-form>
                 </v-flex>
               </v-layout>
            </v-tab-item>
            <v-tab href='#3' v-if="this.$route.query.islem == 'guncelle'" ripple>
              E - mail
            </v-tab>
            <v-tab-item :id="'3'" style="width:100%; height:100%;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text"  flat>
                     <v-form ref="formmail"   lazy-validation>
                    <v-layout flex wrap>
                      <v-text-field v-model="emailKayit.Mail"  label="E-Mail" :rules="[rules.required, rules.email]" >
                      </v-text-field>
                      <v-btn @click="mailKayit" icon>
                        <v-icon color="primary"> add_box</v-icon>
                      </v-btn>
                    </v-layout>
                     </v-form>
                     </v-card>
                </v-flex>
              </v-layout>

                  <v-layout flex="" wrap="" >
                 <v-flex  flat pa-1 xs12 sm6 md6>

                     <v-form ref="formmailguncel"   lazy-validation>
                        <v-card class="white--text"  flat>
                    <template v-for="(item,index) in mailArray">
                      <v-layout flex wrap v-bind:key="item.MusteriKod">
                        <v-flex xs8 sm3 md10>
                          <v-layout align-start justify-start="">
                            <v-card  flat>
                              <v-list-tile>
                                <div class="font-weight-bold body-1">
                                  {{item.Mail}}</div>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md2>
                          <v-layout column="" align-start>
                            <v-card flat>
                              <v-list-tile >
                                <v-list-tile-content >
                                  <v-layout align-center>
                                    <v-flex  flat>
                                      <v-layout column justify-start="" align-start>
                                        <v-card flat >
                                          <v-dialog v-model="emailDuzenle" persistent max-width="400px">
                                            <v-flex xs12 sm12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Güncelle</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn  v-on="on" icon>
                                                <v-icon color="green" @click="mailCek(item,index)">edit</v-icon>
                                              </v-btn>
                                            </template>
                                                  <v-card flat>
                                                      <v-layout row wrap>
                                                         <v-flex>
                                                          <v-layout  xs12 sm12 md12>
                                                            <v-text-field label="E-Mail"
                                                              v-model="emailVeri.Mail" :rules="[rules.required, rules.email]"></v-text-field>
                                                          </v-layout>
                                                        </v-flex>
                                                      </v-layout>
                                                      <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="info" flat @click.native="emailDuzenle = false">Vazgeç</v-btn>
                                                      <v-btn color="info" flat @click="mailGuncelle(item)">Güncelle
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                          </v-dialog>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-card  flat>
                                          <v-dialog v-model="emailSilKontrol" persistent max-width="400px">
                                        <v-flex xs12 sm12 md12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Uyarı!</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn @click="emailSilDialog(item.Ref)" @click.native="emailSilKontrol = true" v-on="on" icon>
                                            <v-icon color="red">delete</v-icon>
                                              </v-btn>
                                            </template>
                                                  <v-card color="grey lighten-5">
                                                      <v-card-text>
                                                    Silmek istediğinize emin misiniz?
                                                  </v-card-text>
                                                      <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="primary" flat  @click.native="emailSilKontrol = false">Vazgeç</v-btn>
                                                      <v-btn color="primary" flat @click="mailSil()" @click.native="emailSilKontrol = false">Tamam
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                
                                          </v-dialog>
                                        </v-card>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider :key="item.id"></v-divider>
                    </template>
                        </v-card>
                     </v-form>
                  
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab href='#4' v-if="this.$route.query.islem == 'guncelle'" ripple> Telefon </v-tab>
            <v-tab-item :id="'4'" style="width:100%; height:100%;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card flat>
                     <v-form ref="formtelefon"  lazy-validation>
                    <v-layout flex wrap>
                      <v-flex pa-1 xs12 sm6 md5>
                      <v-text-field v-model="telKayit.TelTipi" label="Tel Tipi" :rules="[v => !!v || 'Zorunlu alan']" >
                      </v-text-field>
                      </v-flex>
                      <v-flex pa-1 xs12 sm6 md5>
                      <v-text-field   v-model="telKayit.TelefonNo" label="Telefon Numarası" :rules="[v => !!v || 'Zorunlu alan']"
                        ></v-text-field>
                        </v-flex>
                      <v-btn @click="telefonKayit()" icon>
                        <v-icon color="primary"> add_box</v-icon>
                      </v-btn>
                    </v-layout>
                     </v-form>
                    </v-card>
                </v-flex>
              </v-layout>


                     <v-layout flex="" wrap="" >
                 <v-flex  pa-1 xs12 sm6 md6>
                     <v-form ref="formtelefonguncel"  lazy-validation>
                        <v-card class="white--text"  flat>
                    <template v-for="(item,index) in phoneArray">
                      <v-layout flex wrap v-bind:key="item.TelTipi">
                        <v-flex xs3 sm3 md5>
                          <v-layout align-start justify-start="">
                            <v-card  flat>
                              <v-list-tile  flat>
                                <div class="font-weight-bold body-1">
                                  {{item.TelTipi}}</div>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md5>
                          <v-layout column="" align-start>
                            <v-card  flat >
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout class="font-weight-bold body-1" column justify-start="" align-start>
                                          {{item.TelefonNo}}
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md2>
                          <v-layout column="" align-start>
                            <v-card  flat>
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-layout column justify-start="" align-start>
                                        <v-card  flat>
                                          <v-dialog v-model="telefonDuzenle" persistent max-width="400px">
                                            <v-flex xs12 sm12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Güncelle</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn  v-on="on" icon>
                                                <v-icon color="green" @click="telefonCek(item,index)">edit</v-icon>
                                              </v-btn>
                                            </template>
                                            <v-flex>
                                              <v-layout wrap>
                                                <v-card class="white--text">
                                                  <v-card color="grey lighten-5" flat="">
                                                    <v-card-actions>
                                                      <v-layout row wrap>
                                                        <v-flex pa-1 xs12 sm12 md12>
                                                          <v-layout>
                                                            <v-text-field label="Tel Tipi"
                                                              v-model="telVeri.TelTipi" :rules="[v => !!v || 'Zorunlu alan']"></v-text-field>
                                                          </v-layout>
                                                        </v-flex>
                                                        <v-flex pa-1 xs12 sm12 md12>
                                                          <v-layout>
                                                            <v-text-field label="Telefon Numarası"
                                                            v-model="telVeri.TelefonNo" :rules="[v => !!v || 'Zorunlu alan']"></v-text-field>
                                                          </v-layout>
                                                        </v-flex>
                                                      </v-layout>
                                                    </v-card-actions>
                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="info" flat @click.native="telefonDuzenle = false">Vazgeç</v-btn>
                                                      <v-btn color="info" flat @click="telefonGuncelle()">Güncelle
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                                </v-card>
                                              </v-layout>
                                            </v-flex>
                                          </v-dialog>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                   <v-card  flat>
                                          <v-dialog v-model="telSilKontrol" persistent max-width="400px">
                                        <v-flex xs12 sm12 md12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Uyarı!</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn  @click="telefonSilDialog(item.Ref)" @click.native="telSilKontrol = true" v-on="on" icon>
                                            <v-icon color="red">delete</v-icon>
                                              </v-btn>
                                            </template>
                                                  <v-card color="grey lighten-5">
                                                     <v-card-text>
                                                    Silmek istediğinize emin misiniz?
                                                  </v-card-text>
                                                      <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="primary" flat @click.native="telSilKontrol = false">Vazgeç</v-btn>
                                                      <v-btn color="primary" flat @click="telefonSil(item)" @click.native="telSilKontrol = false">Tamam
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                
                                          </v-dialog>
                                        </v-card>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider :key="item.id"></v-divider>
                    </template>
                    </v-card>
                     </v-form>
                  
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab href='#5' v-if="this.$route.query.islem == 'guncelle'" ripple> Sözleşme Bilgileri </v-tab>
            <v-tab-item :id="'5'" style="width:100%; height:100%;">
              <v-layout flex="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card flat >
                    <v-form ref="formsozlesme"  lazy-validation>
                    <v-layout>
                      <v-layout flex wrap>
                        <v-flex xs12 sm4 md4>
                          <v-select  :items="items" v-model="urunKayit.UrunAd" hide-details="" 
                        label="Ürünler"  item-text="UrunAdi" item-value="UrunAdi" max-height="400" :rules="[v => !!v || 'Zorunlu alan']"></v-select>
                        </v-flex>
                        <v-flex xs12 sm4 md3>
                          <tarihim  :etiket="'Alış Tarihi'" :detaygizle="false"
                            v-model="sozlesmeBilgi.SozelesmeBaslangic" v-bind:defaultvalue="'ok'"
                            :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="sozlesmeBilgi.SozelesmeBitis"
                            v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                        </v-flex>
                        <v-flex xs12 sm4 md1>
                          <v-btn @click="sozlesmeKayit()" icon>
                            <v-icon color="primary"> add_box</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    </v-form>
                </v-card>
                </v-flex>
              </v-layout>
              <v-layout flex="" wrap="" >
                 <v-flex pa-1 xs12 sm6 md6>
                    <v-form ref="formsozlesmeguncel"  lazy-validation>
                      <v-card  >
                    <template v-for="(item,index) in contractArray">
                      <v-layout flex wrap v-bind:key="item.TelTipi">
                        <v-flex xs3 sm3 md4>
                          <v-layout align-start justify-start="">
                            <v-card  flat>
                              <v-list-tile >
                                <div  class="font-weight-bold body-1">
                                  {{item.UrunAdi}}</div>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 sm4 md3>
                          <v-layout column="" align-start>
                            <v-card  flat >
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout class="font-weight-bold body-1" column justify-start="" align-start>
                                          {{item.SozelesmeBaslangic | dateformat}}
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 sm4 md3>
                          <v-layout column="" align-start>
                            <v-card  flat>
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout class="font-weight-bold body-1" column justify-start="" align-start>
                                        {{item.SozelesmeBitis | dateformat }}
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
       
                        <v-flex xs4 sm4 md1>
                          <v-layout column="" align-start>
                            <v-card  flat>
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-layout column justify-start="" align-start>
                                        <v-card  flat>
                                          <v-dialog v-model="sozlesmeDuzenle" persistent max-width="400px">
                                            <v-flex xs12 sm12 md12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Güncelle</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn  v-on="on" icon>
                                                <v-icon color="green" @click="sozlesmeCek(item)">edit</v-icon>
                                              </v-btn>
                                            </template>
                                            <v-flex>
                                              <v-layout wrap>
                                                <v-card class="white--text">
                                                  <v-card color="grey lighten-5" flat="">
                                                    <v-card-actions>
                                                      <v-layout row wrap>
                                                        <v-flex pa-1 xs12 sm12 md12>
                                                          <v-layout>
                                                            <v-select  :items="items" v-model="urunKayit.UrunAd" hide-details="" 
                                                          label="Ürünler"  item-text="UrunAdi" item-value="UrunAdi" max-height="400"></v-select>
                                                          </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm4 md6>
                                                          <tarihim :etiket="'Alış Tarihi'" :detaygizle="false"
                                                            v-model="sozlesmeVeri.SozelesmeBaslangic"
                                                            v-bind:defaultvalue="'ok'"
                                                            :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                        </v-flex>
                                                        <v-flex xs12 sm4 md6>
                                                          <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false"
                                                            v-model="sozlesmeVeri.SozelesmeBitis"
                                                            v-bind:defaultvalue="'ok'"
                                                            :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                                        </v-flex>
                                                      </v-layout>
                                                    </v-card-actions>
                                                    <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="info" flat @click.native="sozlesmeDuzenle = false">Vazgeç</v-btn>
                                                      <v-btn color="info" flat @click="sozlesmeGuncelle(index)">Güncelle
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                                </v-card>
                                              </v-layout>
                                            </v-flex>
                                          </v-dialog>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                         <v-card  flat>
                                          <v-dialog v-model="sozlesmeSilKontrol" persistent max-width="400px">
                                        <v-flex xs12 sm12 md12>
                                              <v-toolbar dark color="info">
                                                <v-toolbar-title>Uyarı!</v-toolbar-title>
                                              </v-toolbar>
                                            </v-flex>
                                            <template v-slot:activator="{ on }">
                                              <v-btn @click="sozlesmeSilDialog(item.Ref)" @click.native="sozlesmeSilKontrol = true" v-on="on" icon>
                                            <v-icon color="red">delete</v-icon>
                                              </v-btn>
                                            </template>
                                                  <v-card color="grey lighten-5">
                                                      <v-card-text>
                                                    Silmek istediğinize emin misiniz?
                                                  </v-card-text>
                                                      <v-card-actions>
                                                      <v-spacer></v-spacer>
                                                      <v-btn color="primary" flat @click.native="sozlesmeSilKontrol = false">Vazgeç</v-btn>
                                                      <v-btn color="primary" flat @click="sozlesmeSil(item)" @click.native="sozlesmeSilKontrol = false">Tamam
                                                      </v-btn>
                                                    </v-card-actions>
                                                  </v-card>
                                          </v-dialog>
                                        </v-card>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider :key="item.id"></v-divider>
                    </template>
                     </v-card>
                    </v-form>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab href='#6' v-if="this.$route.query.islem == 'guncelle'" ripple> Booking Bilgileri </v-tab>
            <v-tab-item :id="'6'" style="width:100%; height:100%;">
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </v-form>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </v-card>
  </div>
</template>
<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import tarihim from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {
        valid: true,
        rules: {
          required: (value) => !!value || 'Gerekli alan.',
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Hatalı e-mail.'
          }
        },
        phoneArray: [],
        mailArray: [],
        authorizedArray: [],
        contractArray: [],
        paketAdi:[],
        items: [],
        universe:null,
        telefonDuzenle:false,
        emailDuzenle:false,
        yetkiliDuzenle:false,
        sozlesmeDuzenle:false,
        yetkiliSilKontrol:false,
        emailSilKontrol:false,
        telSilKontrol:false,
        sozlesmeSilKontrol:false,
        Musteri: {
          MusteriID: null,
          MusteriKod: null,
          Grup: null,
          Ad: null,
          Adres: null,
          Ilce: null,
          Sehir: null,
          Ulke: null,
          Tel1: null,
          Tel2: null,
          GSM: null,
          Fax: null,
          Mail: null,
          Web: null,
          Notlar: null,
          Yetkili1: null,
          Yetkili2: null,
          Yetkili3: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          Deleted: null,
          DeletedBy: null,
          DeletedDate: null,
          Sifre: null,
          MusteriIp: null,
          DBCariName: null,
          DBBiletName: null,
          DBPassword: null,
          DBCoperName: null,
          Uid: null,
          AcenteAdi: null,
          Kapandi: false,
          KapandiAciklama: null,
          WebGizle: false,
          CariKod: null,
          WebSiteIP: null,
          BookingYayinIP: null,
          OnemliNot: null,
          UlkeID: null,
          Sirketler: [],
          TelefonList: [],
          MailList: [],
          YetkiliList: [],
          SozlesmeList: [],

        },

        tabcontrol3: 0,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statecari: [],
        search: '',
        search1: '',
        loading: false,

        Current: {
          CompanyCode: '',
          Code: null,
          Title: null,
          Phone1: '',
          Phone2: '',
          Mobile: '',
          Web: '',
          Email: '',
          AccountGroup: '',
          Type: '',
          CMCode: '',
          Reserved1: '',
          Reserved2: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          CustomerType: '',
          TicketBill: '',
          EInvoiceType: '0',
          PostCodeLabel: '',
          EInvoiceCustomer: '',
          MultiPostUse: false,
          EArchiveSendType: 'false',
          EArchiveSendPaper: false,
          CreditLimit: 0,
          CreditLimitCurrencyAmount: 0,
          CreditLimitCurrency: '',
          WebPassword: '',
          PinCode: '',
          MileCode: '',
          ExpiryDayDomestic: '',
          ExpiryTypeDomestic: '',
          ExpiryDayInt: '',
          ExpiryTypeInt: '',
          ExpiryDayGeneral: '',
          ExpiryTypeGeneral: '',
          DiscountGeneral: '',
          DiscountDom: '',
          DiscountInt: '',
          DiscountDomService: '',
          DiscountIntService: '',
          TaxFree: '',
          ExternalCurrentCode: '',
          ExternalAccountingCode: '',
          StreamCurrentCode: '',
          ArkmanStreamCode: '',
          ExpenseCenter: null,
          TemplateID: '',
          ProfileForced: '',
          EventIDForced: '',
          MainAccount: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: '',
            PerFirstName: '',
            PerFamilyName: '',
            PerTitle: '',
            PerMiddleName: '',
            PerNameSuffix: '',
            NoPrint: '',
            CustomerPersonelNoInvoice: '',
            DeliveryAddress: '',
            DeliveryName: ''
          },
          Contract: {
            ContractNumber: '',
            ContractDate: '',
            PaymentType: '',
            BankAccountNumber: '',
            BankBranchOffice: '',
            InvoiceflexNumber: '',
            InvoicePassengerName: '',
            InvoiceFlightNumber: ''
          },
        },
        urunKayit:{
        Ref:null,
        UrunAd :null,
        UrunAciklama:null,
        Aciklama:null,
        },
        telVeri:{
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          TelTipi: null,
          TelefonNo: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
        telKayit: {
          Ref:null,
          MusteriRef:null,
          MusteriKod:null,
          TelTipi:null,
          TelefonNo:null,
          CreatedBy:null,
          CreatedDate:null,
          ModifiedBy:null,
          ModifiedDate:null,
          DeletedBy:null,
          DeletedDate:null,
          Deleted:null,
        },
        sozlesmeBilgi: {
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          UrunID: null,
          UrunAdi: null,
          SozelesmeBaslangic: null,
          SozelesmeBitis: null,
          WebAktif: false,
          Versiyon: null,
          LisansKey: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
          sozlesmeVeri: {
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          UrunID: null,
          UrunAdi: null,
          SozelesmeBaslangic: null,
          SozelesmeBitis: null,
          WebAktif: false,
          Versiyon: null,
          LisansKey: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
        emailKayit: {
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          Mail: null,
          OtoGonder: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
          emailVeri: {
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          Mail: null,
          OtoGonder: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
        yetkiliKayit: {
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          Unvan: null,
          Yetkili: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
           yetkiliVeri: {
          yetkiliID:null,
          Ref: null,
          MusteriRef: null,
          MusteriKod: null,
          Unvan: null,
          Yetkili: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
        },
        kaydetbuton: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        text1: '',

        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        degertel: 0,
        degermail: 0,
        degeryetkili: 0,
        degersozlesme:0,
        ex11: 'false',
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      telefonCek:telefonCek,
      telefonKayit: telefonKayit,
      telefonGuncelle:telefonGuncelle,
      telefonSilDialog:telefonSilDialog,
      telefonSil: telefonSil,
      mailKayit: mailKayit,
      mailGuncelle:mailGuncelle,
      emailSilDialog:emailSilDialog,
      mailCek:mailCek,
      mailSil: mailSil,
      yetkiKayit: yetkiKayit,
      yetkiGuncelle:yetkiGuncelle,
      yetkiSilDialog:yetkiSilDialog,
      yetkiCek:yetkiCek,
      yetkiliSil: yetkiliSil,
      sozlesmeKayit: sozlesmeKayit,
      sozlesmeGuncelle: sozlesmeGuncelle,
      sozlesmeSilDialog:sozlesmeSilDialog,
      sozlesmeCek:sozlesmeCek,
      sozlesmeSil: sozlesmeSil,
      ekle: ekle,
      onChangecheck: onChangecheck,
      onChangecheckdis: onChangecheckdis,
      karsidegeral: karsidegeral,
      carigetir: carigetir,
      guncelle
    },

    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      yuzdeinput,
      tarihim
    },
    watch: {
      
      active: function (val) {
            if (val == 2) {
          if(this.degeryetkili== 0){
          var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.authorizedArray=response.body
          }, (response) => {
            if (response.Status === true) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        this.degeryetkili = 1;
        }
      }
        if (val == 3) {
          if(this.degermail== 0){
          var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod,
            UserID: null,
            UrunID: this.Musteri.Uid
            
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerMailList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.mailArray=response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        this.degermail = 1;
        }
      }
        if (val == 4) {
         if(this.degertel== 0){
          var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.phoneArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        this.degertel = 1;
        }
      }
       if (val == 5) {
          if(this.degersozlesme== 0){
          var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod,
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerContractList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
           this.contractArray=response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        this.degersozlesme = 1;
        }
        this.$http.post(auth.API_URL + 'api/Awed/AwedProductList',null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
      },
      search1(val) {
        val && this.carigetir(val)
      },
      searchcari(val) {
        val && this.carigetir(val)
      },
      'icYuzdedenHesapla.Yuzdeden': function (value) {
        if (value == true) {
          this.icyuzde = true
          this.icYuzdedenHesapla.HesapTipi = 0
        } else {
          this.icyuzde = false
          this.icYuzdedenHesapla.HesapTipi = null
        }
      },
      'DisYuzdedenHesapla.Yuzdeden': function (value) {
        if (value == true) {
          this.disyuzde = true
          this.DisYuzdedenHesapla.HesapTipi = 0
        } else {
          this.disyuzde = false
          this.DisYuzdedenHesapla.HesapTipi = null
        }
      }
    },
      filters:{
         dateformat: function (t) {
        return helpers.dateformat(t);
         },
        }
  }
  function karsidegeral(val) {
    if (val == true) {
      return false
    } else if (val == false) {
      return false
    }
  }
  function onChangecheck(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.ichatdoviztipi1 == true && nerden != 'ichatdoviztipi1') {
      this.ichatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi2 === true && nerden != 'ichatdoviztipi2') {
      this.ichatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi3 === true && nerden != 'ichatdoviztipi3') {
      this.ichatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi4 === true && nerden != 'ichatdoviztipi4') {
      this.ichatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi5 === true && nerden != 'ichatdoviztipi5') {
      this.ichatdoviztipi5 = karsidegeral(elem1)
    }
  }

  function onChangecheckdis(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.dishatdoviztipi1 == true && nerden != 'dishatdoviztipi1') {
      this.dishatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi2 === true && nerden != 'dishatdoviztipi2') {
      this.dishatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi3 === true && nerden != 'dishatdoviztipi3') {
      this.dishatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi4 === true && nerden != 'dishatdoviztipi4') {
      this.dishatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi5 === true && nerden != 'dishatdoviztipi5') {
      this.dishatdoviztipi5 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi6 === true && nerden != 'dishatdoviztipi6') {
      this.dishatdoviztipi6 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi7 === true && nerden != 'dishatdoviztipi7') {
      this.dishatdoviztipi7 = karsidegeral(elem1)
    }
  }
  function carigetir(v) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loading = true
      var params = {
        q: v,
        c: null,
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }
  function beforeMount() {

    if (this.$route.query.islem == 'yeni') {
      this.baslik = 'Yeni Müşteri Ekle'

    } else if (this.$route.query.islem == 'guncelle') {
      this.baslik = 'Müşteri Düzenle'
      var params = {
        CompanyCode: this.$route.query.musterikod
      }
      this.$http.post(auth.API_URL + 'api/Awed/CustomerLoad', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        this.Musteri = response.body
        

      }, (response) => {
        if (response.status === 0) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    }
  }
  function telefonSilDialog(value){
          this.universe= value
   }

    function yetkiSilDialog(value){
          this.universe= value
   }

  function emailSilDialog(value){
          this.universe= value
   }
    function sozlesmeSilDialog(value){
          this.universe= value
   }
  
  function mailSil() {
var emailsil = {
           MailId:this.universe
  }
    var params=emailsil
      this.$http.post(auth.API_URL + 'api/Awed/CustomerMailDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerMailList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.mailArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      }) 
        emailSilKontrol=false
      }
  function telefonSil() {
     var telsil = {
        PhoneId:this.universe
  }
  var params=telsil
      this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.phoneArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
  }
  function sozlesmeSil(itemIndex) {
     var sozlesSil = {
     ContractId:this.universe
  }
    var params=sozlesSil
      this.$http.post(auth.API_URL + 'api/Awed/CustomerContractDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerContractList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            
           this.contractArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
  }
  function yetkiliSil(itemIndex) {
    var yetkiSil = {
      AuthorizedId:this.universe
  }
    var params=yetkiSil
      this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            
           this.authorizedArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
  }
 function telefonGuncelle(){
    if (this.$refs.formtelefonguncel.validate()) {
      var guncel={
          Ref: this.telVeri.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          TelTipi: this.telVeri.TelTipi,
          TelefonNo: this.telVeri.TelefonNo,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
   }    
      this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneSave', guncel, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
          if (response.body.Status==true) {
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.phoneArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
       this.telefonDuzenle=false
         } else {
      this.active = '4';
    }
 }

function telefonCek(value,itemIndex){
      var kayit={
          Ref: value.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          TelTipi: value.TelTipi,
          TelefonNo: value.TelefonNo,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
   }
  this.telVeri = kayit
  this.universe=itemIndex
}

 function mailCek(index,itemIndex){
      var kayit={
          Ref: index.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          Mail: index.Mail,
          OtoGonder: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
   }
  this.emailVeri = kayit
  this.universe=itemIndex
 }
 function mailGuncelle() {
    if (this.$refs.formmailguncel.validate()) {
     var guncel={
          Ref: this.emailVeri.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          Mail: this.emailVeri.Mail,
          OtoGonder: null,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy:null,
          DeletedDate: null,
          Deleted: null,
   }    
      this.$http.post(auth.API_URL + 'api/Awed/CustomerMailSave', guncel, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
            //UpdateDate:null
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerMailList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.mailArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
       this.emailDuzenle=false
       } else {
      this.active = '3';
    }
 }
 function yetkiCek(value,itemIndex){
   var kayit={
          Ref: value.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          Unvan: value.Unvan,
          Yetkili: value.Yetkili,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
   }
  this.yetkiliVeri = kayit
  this.universe=itemIndex
 }
 function yetkiGuncelle() {
    if (this.$refs.formyetkiliguncel.validate()) {
    var guncel={
          Ref: this.yetkiliVeri.Ref,
          MusteriRef: this.Musteri.MusteriID,
          MusteriKod: this.Musteri.MusteriKod,
          Unvan: this.yetkiliVeri.Unvan,
          Yetkili: this.yetkiliVeri.Yetkili,
          CreatedBy: null,
          CreatedDate: null,
          ModifiedBy: null,
          ModifiedDate: null,
          DeletedBy: null,
          DeletedDate: null,
          Deleted: null,
   }    
      this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedSave', guncel, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
          if (response.body.Status==true) {
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.authorizedArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
       this.yetkiliDuzenle=false
        }else{
      this.active='2';
    }

}
  function sozlesmeCek(index){
    var kayit={
      Ref: index.Ref,
      MusteriKod:index.MusteriKod,
      MusteriRef:index.MusteriID,
      UrunID: index.UrunID,
      UrunAdi: index.UrunAdi,
      SozelesmeBaslangic: index.SozelesmeBaslangic,
      SozelesmeBitis: index.SozelesmeBitis,
      WebAktif: null,
      Versiyon: null,
      LisansKey: null,
      CreatedBy: null,
      CreatedDate: null,
      ModifiedBy: null,
      ModifiedDate: null,
      DeletedBy: null,
      DeletedDate: null,
      Deleted: null,
   }
   this.sozlesmeVeri = kayit
 }
  function sozlesmeGuncelle(value) { 
       if (this.$refs.formsozlesmeguncel.validate()) {
    var guncel={
      Ref: this.sozlesmeVeri.Ref,
      MusteriKod:this.Musteri.MusteriKod,
      MusteriRef:this.Musteri.MusteriID,
      UrunID: this.sozlesmeVeri.UrunID,
      UrunAdi: this.urunKayit.UrunAd,
      SozelesmeBaslangic: this.sozlesmeVeri.SozelesmeBaslangic,
      SozelesmeBitis: this.sozlesmeVeri.SozelesmeBitis,
      WebAktif: this.sozlesmeVeri.WebAktif,
      Versiyon: this.sozlesmeVeri.Versiyon,
      LisansKey: this.sozlesmeVeri.LisansKey,
      CreatedBy: null,
      CreatedDate: null,
      ModifiedBy: null,
      ModifiedDate: null,
      DeletedBy: null,
      DeletedDate: null,
      Deleted: null,
   }    
      this.$http.post(auth.API_URL + 'api/Awed/CustomerConractSave', guncel, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
          if (response.body.Status==true) {
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
            //UpdateDate:null
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerContractList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.contractArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
       this.sozlesmeDuzenle=false
           }else{
      this.active='5';
    }
 }
  function mailKayit() {
        if (this.$refs.formmail.validate()) {
    var yenimail = {
      Ref: null,
      MusteriRef: this.Musteri.MusteriID,
      MusteriKod: this.Musteri.MusteriKod,
      Mail: this.emailKayit.Mail,
      OtoGonder: null,
      CreatedBy: null,
      CreatedDate: null,
      ModifiedBy: null,
      ModifiedDate: null,
      DeletedBy: null,
      DeletedDate: null,
      Deleted: null,
    }
    
          var params=yenimail
      this.$http.post(auth.API_URL + 'api/Awed/CustomerMailSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
          this.emailKayit.Mail = ''
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

          if (response.body.Status==true) {
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerMailList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.mailArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
        }else{
      this.active='3';
    }
  }
  function yetkiKayit() {
    if (this.$refs.formyetkili.validate()) {
    var yeniyetkili = {
      Ref: this.Musteri.Ref,
      MusteriRef: this.Musteri.MusteriID,
      MusteriKod: this.Musteri.MusteriKod,
      Unvan: this.yetkiliKayit.Unvan,
      Yetkili: this.yetkiliKayit.Yetkili,
      CreatedBy: null,
      CreatedDate: null,
      ModifiedBy: null,
      ModifiedDate: null,
      DeletedBy: null,
      DeletedDate: null,
      Deleted: null,
    }
    var params=yeniyetkili

      this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          if (response.body.Status==true) {
            this.yetkiliKayit.Unvan=''
            this.yetkiliKayit.Yetkili=''
            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerAuthorizedList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.authorizedArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => {  
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
    }else{
      this.active='2';
    }

  }
  function sozlesmeKayit() {
    if (this.$refs.formsozlesme.validate()) {
    var yenisozlesme = {
      Ref: null,
      MusteriKod:this.Musteri.MusteriKod,
      MusteriRef:this.Musteri.MusteriID,
      UrunID: null,
      UrunAdi: this.urunKayit.UrunAd,
      SozelesmeBaslangic: this.sozlesmeBilgi.SozelesmeBaslangic,
      SozelesmeBitis: this.sozlesmeBilgi.SozelesmeBitis,
      WebAktif: null,
      Versiyon: null,
      LisansKey: null,
      CreatedBy: null,
      CreatedDate: null,
      ModifiedBy: null,
      ModifiedDate: null,
      DeletedBy: null,
      DeletedDate: null,
      Deleted: null,
    }
    

   var params=yenisozlesme

      this.$http.post(auth.API_URL + 'api/Awed/CustomerConractSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.urunKayit.UrunAd=''
          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerContractList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.contractArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
          }else{
      this.active='5';
    }
  }
  function telefonKayit() {
       if (this.$refs.formtelefon.validate()) {
    var yenikayit = {
          Ref:null,
          MusteriRef:this.Musteri.MusteriID,
          MusteriKod:this.Musteri.MusteriKod,
          TelTipi:this.telKayit.TelTipi,
          TelefonNo:this.telKayit.TelefonNo,
          CreatedBy:null,
          CreatedDate:null,
          ModifiedBy:null,
          ModifiedDate:null,
          DeletedBy:null,
          DeletedDate:null,
          Deleted:null,
    } 
  
      var params=yenikayit

      this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.telKayit.TelTipi=''
          this.telKayit.TelefonNo=''
          if (response.body.Status==true) {

            var params = {
            MusteriID: this.Musteri.MusteriID,
            MusteriKod: this.Musteri.MusteriKod
          }
          this.$http.post(auth.API_URL + 'api/Awed/CustomerPhoneList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

           this.phoneArray = response.body

          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        }  
      }, (response) => { 
        
        this.text1 = response.body.ResponseMessage
          this.snackbar = true
      })
        } else {
      this.active = '4';
    }
  }
  function ekle() {
    if (this.$refs.formmusteri.validate()) {
      var params = this.Musteri
      
      this.$http.post(auth.API_URL + 'api/Awed/CustomerSave', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if(response.body!=null){
        this.text1 = "Kayıt İşlemi Tamamlandı"
        this.snackbar = true
        var url = '#/musteri/musteriislem/id?' + 'musterikod=' + response.body + '&islem=guncelle' 
        window.open(url, '_self')
        }
        else{
          this.text1 ="Kayıt İşlemi Başarısız"
        this.snackbar = true
        }
      }, (response) => {
        if (response.Status === true) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    } else {
      this.active = 0;
    }
  }
  function guncelle() {

    if (this.$refs.formmusteri.validate()) {  
      var params = this.Musteri
    
      this.$http.post(auth.API_URL + 'api/Awed/CustomerUpdate', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }, (response) => {
        if (response.Status === true) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
        } else {
          this.text1 = response.statusText
          this.snackbar = true
        }
      })
    } else {
      this.active = 0;
    }

  }
</script>

<style>
</style>